import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dollar-sign" }, null, -1)
const _hoisted_4 = { class: "is-medium" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "field has-addons" }
const _hoisted_8 = { class: "control has-icons-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-left is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-money-bill" })
], -1)
const _hoisted_10 = { class: "control has-icon-right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cart-plus" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expenses, (expense) => {
      return (_openBlock(), _createElementBlock("div", {
        key: expense.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(expense.amount), 1),
          _createElementVNode("i", {
            class: "fas fa-trash-alt",
            onClick: ($event: any) => (_ctx.onDeleteExpense(expense))
          }, null, 8, _hoisted_5)
        ])
      ]))
    }), 128)),
    (_ctx.expenses.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Total expenses: " + _toDisplayString(_ctx.total), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input is-info is-small",
          placeholder: "Lägg till utgift",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amount) = $event))
        }, null, 512), [
          [_vModelText, _ctx.amount]
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", {
          class: "button is-info is-small",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddExpense && _ctx.onAddExpense(...args)))
        }, _hoisted_12)
      ])
    ])
  ]))
}